import IMask from 'imask';
/**
 *
 * `IMask` controller
 *
 *  Usage (`updated` lifecycle):
 *
 *  `new IMaskController(this, this._input, this.mask);`
 *
 *  `this`: component reference
 *
 *  `this._input`: the inner input element reference
 *
 *  `this.mask`: the mask property
 *
 *  Emit `mask-change` on event listeners:
 *
 *  `emit(this, 'mask-change')`
 */
export class IMaskController {
    constructor(host, input, mask) {
        this.host = host;
        this.host.addController(this);
        // @ts-ignore - haven't found a good way to type this
        this._iMaskObject = new IMask(input, { mask: mask });
    }
    hostConnected() {
        this.host.addEventListener('mask-change', this.updateInput);
    }
    updateInput() {
        if (this._iMaskObject) {
            this._iMaskObject._onInput();
        }
    }
    hostDisconnected() {
        this.host.removeEventListener('mask-change', this.updateInput);
        if (this._iMaskObject) {
            this._iMaskObject.destroy();
        }
    }
}
//# sourceMappingURL=imask.js.map